<template>
  <v-footer
    fixed
    color="white"
  >
    <div style="position: relative;width: 100%;">
      <v-row>
        <v-col
          :class="$vuetify.breakpoint.smAndDown ? 'pb-0' : ''"
          class="text-left"
          cols="12"
          md="6"
        >
          <div style="height: 100%;">
            <strong style="vertical-align: sub">Copyright © {{ new Date().getFullYear() }} DXE INC.</strong>
          </div>
        </v-col>
        <v-col
          :class="$vuetify.breakpoint.smAndDown ? 'pt-0 pl-0' : 'text-right padding-for-bot'"
          cols="12"
          md="6"
        >
          <v-btn
            text
            small
            color="black"
            @click="moveToPollicy"
          >
            プライバシーポリシー
          </v-btn>
          <v-btn
            text
            small
            color="black"
            @click="moveToTearms"
          >
            利用規約
          </v-btn>
          <v-btn
            text
            small
            color="black"
            @click="moveToCompany"
          >
            運営会社
          </v-btn>
          <v-chip
            v-if="$vuetify.breakpoint.mdAndUp"
            class="ma-2"
            small
          >
            Ver.{{ version }}
          </v-chip>
        </v-col>
      </v-row>
    </div>
  </v-footer>
</template>

<script>

/**
 * セッション用フッター
 */

export default {
  name: 'FooterNav',
  data() {
    return {
      version: require('../../../package.json').version,
    }
  },
  computed: {
  },
  created() {
  },
  methods: {
    moveToPollicy () {
      window.open( 'https://dx-e.net/privacy/', "_blank" )
    },
    moveToTearms() {
      window.open( 'https://dx-e.net/terms/', "_blank" )
    },
    moveToCompany() {
      window.open( 'https://dx-e.net/company/', "_blank" )
    }
  },
}

</script>

<style lang="scss">
.padding-for-bot {
  padding-right: 65px !important;
}
</style>
